import { rankingItems, hotTags, leadSide } from "@/mocks/gossip";

export default function Ranking() {
  const champion = rankingItems[0];
  return (
    <section id="ranking" className="border-y border-background-200 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
          {/* main ranking */}
          <div className="lg:col-span-8">
            <div className="flex flex-wrap items-end justify-between gap-3">
              <div>
                <div className="flex items-center gap-2">
                  <span className="grid h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
                    <i className="ri-fire-fill"></i>
                  </span>
                  <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">热度飙升榜</h2>
                </div>
                <p className="mt-1.5 text-sm text-foreground-500">每分钟更新的吃瓜风向标 · 本期截取前 10</p>
              </div>
              <div className="flex gap-1.5">
                {["飙升", "新晋", "热议"].map((t, i) => (
                  <span
                    key={t}
                    className={`chip px-3 py-1.5 text-xs ${i === 0 ? "bg-primary-500 text-background-50" : "bg-background-50 text-foreground-600 border border-background-300"}`}
                  >
                    {t}
                  </span>
                ))}
              </div>
            </div>

            <ol className="mt-6 overflow-hidden rounded-xl border border-background-200 bg-background-50">
              {rankingItems.map((r, i) => (
                <li key={r.id}>
                  <a
                    href="#feed"
                    className={`group flex items-center gap-3 px-3 py-2.5 transition-colors hover:bg-background-100/70 md:gap-4 md:px-4 ${
                      i !== rankingItems.length - 1 ? "border-b border-background-100" : ""
                    }`}
                  >
                    <span
                      className={`w-6 shrink-0 text-center font-heading text-xl font-black ${
                        i < 3 ? "text-primary-500" : "text-foreground-300"
                      }`}
                    >
                      {i + 1}
                    </span>
                    <span className="hidden w-14 shrink-0 md:block">
                      <span className="chip bg-background-200 px-2 py-0.5 text-[11px] text-secondary-800">{r.kind}</span>
                    </span>
                    <div className="min-w-0 flex-1">
                      <p className="truncate text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                        {r.name}
                      </p>
                      <p className="text-[11px] text-foreground-400">{r.type}</p>
                    </div>
                    <span
                      className={`hidden shrink-0 items-center gap-1 text-xs sm:inline-flex ${
                        r.up ? "text-primary-600" : "text-secondary-600"
                      }`}
                    >
                      <i className={r.up ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
                      {r.delta}
                    </span>
                    <div className="hidden w-40 shrink-0 lg:block">
                      <div className="h-1.5 w-full overflow-hidden rounded-full bg-background-200">
                        <div
                          className="h-full rounded-full bg-gradient-to-r from-accent-400 to-primary-500"
                          style={{ width: `${r.heat}%` }}
                        ></div>
                      </div>
                    </div>
                    <span className="w-16 shrink-0 text-right font-label text-sm font-bold text-foreground-950">
                      {r.heat}
                      <span className="text-[10px] font-normal text-foreground-400"> 热</span>
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </div>

          {/* right rail: champion + hot tags */}
          <aside className="flex flex-col gap-5 lg:col-span-4">
            <div className="overflow-hidden rounded-xl bg-foreground-950 text-background-50">
              <div className="p-5">
                <div className="flex items-center justify-between">
                  <span className="flex items-center gap-1.5 text-xs text-accent-400">
                    <i className="ri-trophy-line"></i>本期冠军档案
                  </span>
                  <span className="text-[11px] text-foreground-500">持续 6 小时</span>
                </div>
                <h3 className="mt-3 font-heading text-2xl font-bold text-background-50">阿诺与团团</h3>
                <p className="mt-2 text-sm leading-relaxed text-background-200/90">
                  一场连麦引起的连锁反应，让这对主播的旧账被逐条翻出，两家粉丝深夜对线，热度还在往上蹿。
                </p>
                <div className="mt-4 flex flex-wrap gap-2 text-xs">
                  <span className="chip bg-accent-500/20 px-2.5 py-1 text-accent-300">热度 98.6</span>
                  <span className="chip bg-primary-500/25 px-2.5 py-1 text-primary-200">讨论 5.4万</span>
                  <span className="chip bg-background-200/15 px-2.5 py-1 text-foreground-200">新瓜 12</span>
                </div>
              </div>
              <div className="grid grid-cols-3 divide-x divide-background-800 border-t border-background-800 text-center">
                {[
                  { k: "峰值在线", v: "312万" },
                  { k: "掉粉", v: "-8.6万" },
                  { k: "涨粉", v: "+41万" },
                ].map((s) => (
                  <div key={s.k} className="px-2 py-3">
                    <div className="font-heading text-base font-bold text-background-50">{s.v}</div>
                    <div className="text-[11px] text-foreground-500">{s.k}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="rounded-xl border border-background-200 bg-background-50 p-5">
              <div className="flex items-center justify-between">
                <h3 className="flex items-center gap-1.5 font-heading text-base font-bold text-foreground-950">
                  <i className="ri-price-tag-3-line text-accent-500"></i>热议切片
                </h3>
                <a href="#feed" className="text-xs text-primary-600 hover:text-primary-700">全部</a>
              </div>
              <div className="mt-4 flex flex-wrap gap-2">
                {hotTags.map((t) => (
                  <a
                    key={t}
                    href="#feed"
                    className="chip border border-background-200 bg-background-100 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-accent-400 hover:text-accent-800"
                  >
                    <i className="ri-hashtag text-[10px]"></i>
                    {t}
                  </a>
                ))}
              </div>
              <div className="mt-4 border-t border-dashed border-background-200 pt-4">
                <p className="text-xs leading-relaxed text-foreground-500">
                  排名参考全站实时热度、讨论量与站队比动态计算，仅代表当前围观热度，不构成对人物与事件的定论。
                </p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}